import { render, staticRenderFns } from "./MainContactModal.vue?vue&type=template&id=da35fdc8&"
import script from "./MainContactModal.vue?vue&type=script&lang=js&"
export * from "./MainContactModal.vue?vue&type=script&lang=js&"
import style1 from "./MainContactModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports